import { freeze } from 'icepick';
import { type SetAction, SET } from './actions.tsx';

export type ErrorState = {
	message?: string;
};

type Action = SetAction;

export const initialState: ErrorState = freeze({
	message: undefined,
});

const error = (state: ErrorState = initialState, action: Action) => {
	switch (action.type) {
		case SET: {
			return freeze({ message: action.payload.message });
		}
		default:
			return state;
	}
};

export default error;
